import { render, staticRenderFns } from "./TypeOfFullScreenDisplay.vue?vue&type=template&id=0791ae7b&scoped=true&"
import script from "./TypeOfFullScreenDisplay.vue?vue&type=script&lang=js&"
export * from "./TypeOfFullScreenDisplay.vue?vue&type=script&lang=js&"
import style0 from "./TypeOfFullScreenDisplay.vue?vue&type=style&index=0&id=0791ae7b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0791ae7b",
  null
  
)

export default component.exports